var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      !_vm.isForComponent
        ? _c(
            "el-row",
            { staticStyle: { "margin-bottom": "30px" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                [_vm._v("添加类目")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onUpdate } },
                [_vm._v("变更类目")]
              ),
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.onDel } },
                [_vm._v("删除类目")]
              )
            ],
            1
          )
        : _vm._e(),
      _c("el-tree", {
        ref: "tree",
        staticClass: "filter-tree",
        attrs: {
          data: _vm.data,
          props: _vm.defaultProps,
          "node-key": "id",
          "highlight-current": true,
          "expand-on-click-node": false,
          "show-checkbox": true,
          "check-strictly": true,
          "default-expanded-keys": _vm.expandedArr
        },
        on: {
          "node-collapse": _vm.handleNodeCollapse,
          "check-change": _vm.handleCheckChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.dialogVisible,
            title: _vm.type == "add" ? "新增操作" : "修改操作"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "right"
              }
            },
            [
              _vm.type == "add"
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "父类目:", prop: "parentName" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入",
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formData.parentName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "parentName", $$v)
                                  },
                                  expression: "formData.parentName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "类目名称:", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.name,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "name", $$v)
                              },
                              expression: "formData.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注:", prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }